import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

export default function Menu({ menu }) {
    const location = useLocation();

    return (
        <div className="grid gap-2">
            {menu.map((item, index) => { 
                if (item.type === "divider") {
                    return <div key={`divider-${index}`} className="h-[0.5px] bg-gray-300 my-2 w-full" />;
                }

                const isActive = item.path === location.pathname;

                return (
                    <div key={item.name}>
                        {item.icon && (
                            <Link
                                type="button"
                                to={item.path || "#"}
                                className={[
                                    "w-full flex items-center justify-between 2xl:h-12 h-10 rounded-xl 2xl:px-4 px-3",
                                    "hover:bg-white transition",
                                    isActive ? "bg-white" : "",
                                ].join(" ")}
                            >
                                <div className="flex items-center 2xl:space-x-4 space-x-3">
                       
                                    <item.icon className="2xl:w-5 2xl:h-5 w-4 h-4 shrink-0" />
                                    <span className="font-semibold truncate whitespace-nowrap 2xl:text-base text-sm">{item.name}</span>
                                </div>

                                {item.subItems.length > 0 && (
                                    <img
                                        src="/icons/chevron_down.svg"
                                        alt="chevron"
                                        className={`w-6 h-6 transform transition-transform rotate-180`}
                                    />
                                )}
                            </Link>
                        )}

                        {!item.icon && (
                            <div className="2xl:mt-5 mt-3 mb-1 2xl:px-4 px-3 text-[10px] font-semibold uppercase tracking-wider text-gray-500">
                                {item.name}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

Menu.propTypes = {
    menu: PropTypes.array.isRequired,
};
